import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
/***
 * ANIMAZIONE HOMEPAGE
 */
const scrollerHomepage = document.querySelector(".scrollerHomepage");
if (scrollerHomepage !== null) {
    gsap.registerPlugin(ScrollTrigger);

    $(".img-container-clipped-rettangolare-portrait").each(function (i, el) {
        const itempicture = $(el).find(".img-clipped");
        const delay = parseInt($(el).data("delay"));
        gsap.to(itempicture, {
            //clipPath: "inset(calc(50% - max(130px, 13vw)) calc(50% - max(100px, 10vw)))",
            clipPath: "inset(calc(3%) calc(50% - max(200px, 10vw)))",
            ease: "power2.out",
            duration: 1,
            delay: delay,
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
            },
        });
        const datiCategoriaHome = $(el).find(".datiCategoriaHome");
        gsap.to(datiCategoriaHome, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });
        const lenteExpander = $(el).find(".lente-expander");
        gsap.to(lenteExpander, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });
    });

    $(".img-container-clipped-tondo").each(function (i, el) {
        const itempicture = $(el).find(".img-clipped");
        const delay = parseInt($(el).data("delay"));
        gsap.to(itempicture, {
            //clipPath: "circle(max(150px, 10vw) at 50% 50%)",
            clipPath: "inset(calc(3%) calc(50% - max(200px, 10vw)))",
            ease: "power2.out",
            duration: 1,
            delay: delay,
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
            },
        });
        const datiCategoriaHome = $(el).find(".datiCategoriaHome");
        gsap.to(datiCategoriaHome, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });

        const lenteExpander = $(el).find(".lente-expander");
        gsap.to(lenteExpander, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });
    });

    $(".img-container-clipped-quadrato").each(function (i, el) {
        const itempicture = $(el).find(".img-clipped");
        const delay = parseInt($(el).data("delay"));
        gsap.to(itempicture, {
            //clipPath: "inset(calc(50% - max(100px, 10vw)) calc(50% - max(100px, 10vw)))",
            clipPath: "inset(calc(3%) calc(50% - max(200px, 10vw)))",
            ease: "power2.out",
            duration: 1,
            delay: delay,
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
            },
        });
        const datiCategoriaHome = $(el).find(".datiCategoriaHome");
        gsap.to(datiCategoriaHome, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });

        const lenteExpander = $(el).find(".lente-expander");
        gsap.to(lenteExpander, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });
    });

    $(".img-container-clipped-rettangolare-landscape").each(function (i, el) {
        const itempicture = $(el).find(".img-clipped");
        const delay = parseInt($(el).data("delay"));
        gsap.to(itempicture, {
            //clipPath: "inset(calc(50% - max(87px, 8.7vw)) calc(50% - max(150px, 15vw)))",
            clipPath: "inset(calc(3%) calc(50% - max(200px, 10vw)))",
            ease: "power2.out",
            duration: 1,
            delay: delay,
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
            },
        });
        const datiCategoriaHome = $(el).find(".datiCategoriaHome");
        gsap.to(datiCategoriaHome, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });

        const lenteExpander = $(el).find(".lente-expander");
        gsap.to(lenteExpander, {
            opacity: 1,
            ease: "power3.in",
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
                scrub: 6,
            },
        });
    });

    /***const itemssquare = gsap.utils.toArray(".img-container-clipped-square");

    itemssquare.forEach((item, i) => {
        gsap.to(item, {
            clipPath: "polygon(25% 25%, 75% 25%, 75% 75%, 25% 75%);",
            duration: 4,
            ease: "none",
            scrollTrigger: {
                trigger: item,
                start: "top 95%",
                end: "top 5%",
                scrub: 4,
                markers: true,
            },
        });
    });
    **/
}
$(document).ready(function () {
    $("body").on("click", ".lente-expander", function (e) {
        $(this)
            .closest(".video-container")
            .find(".imgFasciaHomeCategoriadet2 img")
            .toggleClass("expanded");
    });
});
